import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageFull, PageTitle, Grey_Link } from 'monica-alexandria';
import { open_email_marketing } from './emailMarketingNavigation';

// Preserve bookmarks while the directory and settings now belong to one app.
export default function INTEGRATIONS_REDIRECT() {
    const {lang = 'en', '*': path} = useParams();
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [error, setError] = useState('');
    useEffect(() => {
        const selection = path === 'manage' ? params.get('provider') : path;
        try { open_email_marketing(selection, lang); }
        catch (failure) { setError(failure.message); }
    }, [path, lang, params]);
    return <PageFull><PageTitle><h1>{t('Integrations')}</h1></PageTitle>
        <p role="status">{t(error || 'Opening Integrations...')}</p>
        {error ? <Grey_Link text={t('Back to CRM')} onClick={() => navigate(`/${lang}/crm`)} /> : null}
    </PageFull>;
}
